const reviews = [
  {
    name: 'Shelly Kar',
    text: 'Mo, Zena & Abdi are amazing. Been going here for over 12 months and always enjoy coming back. The quality is consistently excellent and the atmosphere is always welcoming.',
    rating: 5,
  },
  {
    name: 'Marwan',
    text: 'Mohammed is an amazing barber. The shop is super clean and the music selection is great. Always leave feeling fresh and confident with my new cut.',
    rating: 5,
  },
  {
    name: 'Joshua Young',
    text: 'Zena & Mo are fantastic barbers and always deliver a great haircut. Professional service every single time, highly recommend to anyone looking for quality.',
    rating: 5,
  },
  {
    name: 'Ashleigh Pearson',
    text: 'Very friendly staff and great haircuts every time. The team really knows what they\'re doing and always make sure you\'re happy with the result.',
    rating: 5,
  },
  {
    name: 'Shaun Ralph',
    text: 'Amazing skill from the team. Abdi did a fantastic job on my hair and beard. The attention to detail is incredible and the results speak for themselves.',
    rating: 5,
  },
  {
    name: 'Liam O\'Leary',
    text: 'First time here and I\'ll definitely be back. Top notch cut and great service. The barbers really take their time to get everything perfect.',
    rating: 5,
  },
];

export default function Reviews() {
  return (
    <section id="reviews" className="py-24 bg-red-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="text-red-600 text-xs tracking-widest font-semibold mb-4 whitespace-nowrap">TESTIMONIALS</div>
          <h2 className="text-6xl md:text-7xl font-bold text-black mb-6">What Clients Say</h2>
          <p className="text-gray-600 text-lg">Real reviews from real customers</p>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reviews.map((review, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-1"
            >
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(review.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-2xl text-red-600"></i>
                ))}
              </div>

              {/* Quote Mark */}
              <div className="text-red-200 text-6xl leading-none mb-4">&ldquo;</div>

              {/* Review Text */}
              <p className="text-gray-700 text-lg italic leading-relaxed mb-6">
                {review.text}
              </p>

              {/* Reviewer */}
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-red-600 rounded-full flex items-center justify-center">
                  <span className="text-white font-bold text-lg">{review.name.charAt(0)}</span>
                </div>
                <div>
                  <div className="font-bold text-black text-lg">{review.name}</div>
                  <div className="flex items-center gap-2">
                    <span className="text-sm text-gray-500">Verified Customer</span>
                    <div className="w-5 h-5 bg-green-500 rounded-full flex items-center justify-center">
                      <i className="ri-check-line text-white text-xs"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}